'use strict';

angular.module('ecrd')
    .factory('RulesService', ['CoreRules', function RulesService(CoreRules) {
        var publicAPI = {};
        // 1. Custom functions

        // 2. Inherited public
        Object.getOwnPropertyNames(Object.getPrototypeOf(CoreRules)).forEach(function(key) {
            if (typeof CoreRules[key] == 'function' && key != 'constructor' && key.indexOf('_') !== 0) {
                if (typeof publicAPI[key] != 'undefined') {
                    throw new Error("Function "+key+" is present in Core object");
                }
                publicAPI[key] = CoreRules[key].bind(CoreRules);
            }
        });

        return publicAPI;
    }]);
